(function () {
  angular
    .module('kareo.ui.shared.directives.validation.input-group-error', [])
    .directive('inputGroupError', inputGroupError);

  function inputGroupError() {
    return {
      link,
      require: '^^inputGroup',
      restrict: 'A',
      scope: {
        errors: '@inputGroupError' // comma separated string
      }
    };
  }

  function link(scope, element, attrs, inputGroup) {
    var isVisible;
    var visibleErrors = [];

    init();

    // ------------------------------------------------------------------------

    function init() {
      if (!!scope.errors) {
        visibleErrors = splitAndTrimAll(scope.errors);
      }
      hide();
      watch();
    }

    function watch() {
      scope.$watch(getErrors, refreshErrors, true);
    }

    function getErrors() {
      var input = inputGroup.getInput();
      return !!input ? input.$error : {};
    }

    function hasVisibleError(errors) {
      var i;
      for (i = 0; i < visibleErrors.length; i++) {
        if (errors[visibleErrors[i]]) {
          return true;
        }
      }
      return false;
    }

    function hide() {
      isVisible = false;
      element.addClass('hide');
    }

    function refreshErrors(errors) {
      if (!isVisible && hasVisibleError(errors)) {
        show();
      } else if (isVisible) {
        hide();
      }
    }

    function show() {
      isVisible = true;
      element.removeClass('hide');
    }

    function splitAndTrimAll(str) {
      return str
        .split(',')
        .map((s) => {
          return s.trim();
        });
    }
  }
})();
